<template>
  <div>
    <Loading v-if="loading"/>
    <div>
      <AppHeader/>

      <section class="disclaimer navbar-space">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-12">
              <div class="secondary-title">
                <h5 class="dis-title">ข้อสงวนสิทธิ์เกี่ยวกับความรับผิดของธนาคาร</h5>
              </div>
              <div class="dis-text-box">
                <!--<h6>ข้อมูลอิเล็กทรอนิกส์</h6>
                <p>
                  เมื่อท่านลงชื่อเข้าใช้และใช้ช่องทางการจองซื้อหลักทรัพย์ออนไลน์นี้
                  <b>("KTB Money Connect")</b>
                  ท่านได้ติดต่อทางอิเล็กทรอนิกส์กับธนาคารและยินยอมรับการติดต่อสื่อสารทางอิเล็กทรอนิกส์ที่ เกี่ยวข้องกับการจองซื้อหลักทรัพย์ออนไลน์ของท่าน
                  ท่านตกลงและยอมรับว่า สัญญา การแจ้งเตือน การเปิดเผย รูปภาพ ข้อมูล และข้อมูลอิเล็กทรอนิกส์อื่นใด (รวมเรียกว่า
                  "ข้อมูลอิเล็กทรอนิกส์") ที่ได้ส่งถึง ส่งจาก หรือแลกเปลี่ยนกันระหว่างท ่านและธนาคารโดยวิธีการทางอิเล็กทรอนิกส์จะมีผลใช้บังคับได้เช่นเดียวกับเอกสารที่มีการลงลายมือชื่อ
                  เป็นลายลักษณ์อักษร และในกระบวนการพิจารณาคดีทางศาลหรือกระบวนการระงับข้อพิพาทอื่นใด ท่านจะไม่กล่าวอ้างว่าข้อมูลอิเล็กทรอนิกส์นั้นไม่มีคุณสมบัติครบตามข้อกำหนดของเอกสารที่มีการลงลายมือชื่อเป็นลายลักษณ์อักษร
                  หรือกล่าวอ้างว่าข้อมูลอิเล็กทรอนิกส์นั้นไม่มีผลใช้บังคับหรือถือว่าไม่มีอยู่ การที่ท่านลงชื่อเข้าใช้ด้วยชื่อผู้ใช้และรหัสผ่านของท่านนั้น
                  เป็นการที่ท่านยืนยันและรับรองความถูกต้องครบถ้วนของข้อมูลอิเล็กทรอนิกส์ และเป็นการยืนยันความถูกต้องของสำเนาข้อมูลดังกล่าวและ
                  ลงลายมือชื่อรับรอง
                </p>
                <h6>การทำธุรกรรมผ่านบัญชีของท่าน</h6>
                <p>
                  ท่านจะต้องเก็บรักษาชื่อผู้ใช้และรหัสผ่านเป็นความลับและต้องไม่เปิดเผยข้อมูลส่วนตัวใดๆ ที่เกี่ยวข้องกับบัญชีของท่านกับบุคคลใดๆ
                  ท่านตกลงและยอมรับว่า การกระทำใด ๆ ผ่านช่องทาง KTB Money Connect โดยใช้ Net ID และ/หรือ รหัสผ่าน และ/หรือ รหัส
                  One-Time Password (OTP) ซึ่งเกี่ยวข้องกับบริการ KTB netbank เป็นการกระทำที่มีผลสมบูรณ์ที่ท่านได้กระทำด้วยตนเอง
                  และท่านจะรับผิดชอบในการกระทำดังกล่าวในทุกกรณี
                </p>
                <h6>ความยินยอมในการเปิดเผยข้อมูลส่วนบุคคล</h6>
                <p>
                  ข้อมูลส่วนตัวของท่านอาจถูกเก็บรวบรวม ใช้ ประมวลผล เปิดเผย และ/หรือ ส่งต่อไปยังบุคคลภายนอกตามความจำเป็น เพื่อการดำเนินการจองซื้อหลักทรัพย์ออนไลน์ของท่าน
                  หรือตามที่กฎหมายกำหนด ซึ่งรวมถึงการส่งข้อมูลไปยังนายทะเบียนหลักทรัพย์ด้วย โปรดตรวจสอบอย่างรอบคอบเกี่ยวกับวิธีในการเก็บ
                  ใช้ ประมวลผล เปิดเผย และ/หรือ ส่งต่อข้อมูลส่วนตัวของท่าน และสิทธิของท่านในข้อมูลส่วนตัว ซึ่งเป็นการเปิดเผยข้อมูลที่สำคัญที่กำหนดไว้ในนโยบายความเป็นส่วนตัว
                  ซึ่งถือเป็นส่วนหนึ่งของข้อตกลงและเงื่อนไข โดยท่านสามารถตรวจสอบนโยบายความเป็นส่วนตัวได้ที่
                  <a
                    href="https://www.ktbnetbank.com/CMS/th/contents/product/product_content_privacy.html"
                  >https://www.ktbnetbank.com/CMS/th/contents/product/product_content_privacy.html</a> การที่ท่านลงชื่อเข้าใช้ และใช้ หรือยังใช้ KTB Money Connect ถือว่าท่านได้อ่านและยอมรับนโยบายความเป็นส่วนตัวนี้แล้ว
                  และท่านยินยอมให้ธนาคารเก็บ ใช้ ประมวลผล เปิดเผย และ/หรือ ส่งต่อข้อมูลส่วนตัวของท่านได้ตามที่กำหนดในนโยบายความเป็นส่วนตัวดังกล่าว
                </p>
                <h6>การปฏิเสธการรับประกัน</h6>
                <p>
                  ช่องทาง KTB Money Connect และเนื้อหาทั้งหมดที่ปรากฏใน KTB Money Connect ถูกนำเสนอและสามารถเข้าถึงได้แบบ "ตามสภาพที่เป็นอยู่"
                  และ "ตามที่มีอยู่" ภายในขอบเขตที่ได้รับอนุญาตตามกฎหมายที่ใช้บังคับ ธนาคารปฏิเสธการรับรอง การรับประกัน และเงื่อนไขใดๆ
                  ทั้งหมดไม่ว่าโดยชัดแจ้ง โดยนัย หรือตามกฎหมาย ที่เกี่ยวกับการปฏิบัติการของ KTB Money Connect หรือเนื้อหา หรือข้อมูลอื่นใดในที่ปรากฏใน
                  KTB Money Connect ซึ่งรวมถึงแต่ไม่จำกัดเพียงการรับรอง การรับประกัน และเงื่อนไขใดๆ ในเรื่องกรรมสิทธิ์ การไม่ละเมิดสิทธิ
                  การไม่แทรกแซง ความเหมาะสมในเชิงพาณิชย์ ความเหมาะสมเพื่อวัตถุประสงค์เฉพาะอย่าง หรือการรับประกันโดยนัยอันเกิดจากวิธีการชำระหนี้หรือวิธีปฏิบัติระหว่างคู่กรณี
                </p>
                <p>
                  ธนาคารไม่รับประกันว่าช่องทาง KTB Money Connect จะสามารถใช้งานได้อย่างสมบูรณ์บนอุปกรณ์หนึ่งอุปกรณ์ใดโดยเฉพาะ การให้บริการ
                  KTB Money Connect อาจไม่สามารถดำเนินการได้ตามปกติ และ/หรือ เกิดความล่าช้า อันเนื่องมาจากการใช้งานอินเตอร์เน็ต
                  ความเร็วอินเตอร์เน็ต หรือความหนาแน่นในการติดต่อสื่อสารทางอิเล็กทรอนิกส์
                </p>
                <p>
                  ธนาคารสงวนสิทธิ์ที่จะรับหรือปฏิเสธการจัดสรรหลักทรัพย์หรือการลงทะเบียนการโอนหลักทรัพย์ให้แก่บุคคลใดก็ได้ โดยบุคคลที่ธนาคารจะไม่เสนอหลักทรัพย์หรือไม่รับลงทะเบียนการโอนหลักทรัพย์ให้นั้น
                  รวมถึงแต่ไม่จำกัดเพียง บุคคลที่ต้องห้ามมิให้จัดสรรหลักทรัพย์ให้ตามประกาศคณะกรรมการกำกับตลาดทุน พลเมืองสหรัฐอเมริกา
                  ผู้ที่มีถิ่นฐานอยู่ในสหรัฐอเมริกา บุคคลซึ่งปกติมีถิ่นที่อยู่ในสหรัฐอเมริกา รวมถึงกองทรัพย์สินของบุคคลดังกล่าว
                  และบริษัทหรือห้างหุ้นส่วนซึ่งจัดให้มีขึ้นและดำเนินกิจกรรมในสหรัฐอเมริกา
                </p>
                <h6>การจำกัดความรับผิดและการชดใช้ความเสียหาย</h6>
                <p>
                  ท่านตกลงว่าธนาคารไม่ต้องรับผิดต่อท่านสำหรับความสูญเสียหรือความเสียหายใด ๆ ที่เกิดขึ้นเนื่องจากการใช้บริการ KTB
                  Money Connect เว้นแต่ความสูญเสียหรือเสียหายนั้นเกิดจากการผิดข้อตกลงและเงื่อนไข การฉ้อโกง หรือความประมาทเลินเล่ออย่างร้ายแรงของธนาคาร
                </p>
                <p>
                  ท่านตกลงจะชดใช้สินไหมทดแทน หรือค่าเสียหายใดๆ และจะปกป้องธนาคาร จากการเรียกร้องใด ๆ ค่าใช้จ่ายต่าง ๆ และค่าทนายความที่เกิดจากการกระทำดังต่อไปนี้ของท่าน
                  (1) การผิดข้อตกลงและเงื่อนไข (2) การฉ้อโกง การกระทำผิด หรือความประมาทใด ๆ (3) การใช้บริการ KTB Money Connect
                  ในทางที่ผิด และ (4) การละเมิดกฎหมายหรือกฎเกณฑ์ใดๆ
                </p>-->
                <div class="accept-checkbox-wrapper">
                  <div class="form-check">
                    <b-form-checkbox
                      id="acceptStatus"
                      v-model="acceptStatus"
                      name="acceptStatus"
                      value="1"
                      unchecked-value="0"
                    >
                      ข้าพเจ้าขอรับรองว่ารายละเอียดของคำขอเกี่ยวกับหนังสือค้ำประกันตามที่ระบุไว้ข้างต้นถูกต้อง และตรงตามความประสงค์ของข้าพเจ้าทุกประการ และให้อยู่ภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการเกี่ยวกับหนังสือค้ำประกันที่ข้าพเจ้าได้ลงนามและ/หรือตกลงผูกพันไว้ก่อนหน้านี้ นอกจากนี้ หากหนังสือค้ำประกันดังกล่าวเป็นการขอให้ออกโดยให้วันที่มีผลใช้บังคับของหนังสือค้ำประกันมีผลย้อนหลัง ข้าพเจ้าขอรับรองว่า ในช่วงตั้งแต่วันที่หนังสือค้ำประกันมีผลใช้บังคับย้อนหลังจนถึงวันที่ออกหนังสือค้ำประกันตามความประสงค์ที่แจ้งไว้ ไม่มีเหตุผิดนัด/ผิดสัญญาตามสัญญาและ/หรือหนี้ที่ธนาคารค้ำประกันตามหนังสือค้ำประกันแต่อย่างใด      
                    </b-form-checkbox>

                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 col-sm-11 col-lg-9 col-xl-9">
                  <div class="cta-btn">

                  <button
                    type="button"
                    @click="reject()"
                    class="btn btn-lg btn-outline-ktb"
                  >ออกจากระบบ</button>

                  <button
                    type="button"
                    @click="accept()"
                    :disabled="this.acceptStatus !== '1'"
                    class="btn btn-lg btn-primary-ktb"
                  >ตกลงและยอมรับ</button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";

import { apiClient } from "@/utils/apiClient";

export default {
  components: {
    AppFooter,
    AppHeader
  },
  name: "disclaimer",
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  },
  data() {
    return {
      disclaimerText: "",
      acceptStatus:0,
    };
  },
  mounted() {
    this.disclaimerText = "ไป Load เพิ่ม";
  },
  methods: {
    reject: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push("/");
      });
    },
    accept: function() {

      let config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.$store.state.auth.token //localStorage.getItem("user-token")
        }
      };

      this.loader = this.$loading.show();

      let registerVerifyId = localStorage.getItem("registerVerifyId")
      let taxId = localStorage.getItem("taxId")

      if(registerVerifyId===null||registerVerifyId===""){
        registerVerifyId = 0;// ให้้ get ใหม่
      }


      apiClient
        .post(
          "/api/customer/accept/" +registerVerifyId +"/A",
          {},
          config
        )
        .then(resp => {
          this.loader.hide();

          console.log("resp.data.code : "+resp.data.code);
          console.log("resp.data.registerVerifyId : "+resp.data.registerVerifyId);
          if (resp.data.code == "0000") {
            //success

            localStorage.setItem("registerVerifyId",resp.data.registerVerifyId)
            this.$router.push("/lgmain");
            //       //this.$router.push("/lghead");
            //       //this.$router.push("/lgapp/"+this.$route.params.registerVerifyId+"/"+this.$route.params.taxId);
          }else if (resp.data.code == "1000"){//กรณี user สปสช
            localStorage.setItem("registerVerifyId",resp.data.registerVerifyId)
            this.$router.push("/lgsearch");
          }else if (resp.data.code == "0001") {//กรณีไม่มีวงเงินเลย Popup แจ้งลูกค้าแล้ว force  logout

            let message = resp.data.message;
            this.$swal.fire({
              title: 'Invalid profile',
              text: "ไม่พบวงเงินสำหรับออกหนังสือค้ำประกันและบัญชีเงินฝาก",
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              if (result.value) {
                this.$store.dispatch(AUTH_LOGOUT).then(() => {
                  this.$router.push("/");
                });
              }
            })

          }
        }).catch(err => {
          this.loader.hide();
        });
    }
  }
};
</script>
